<template>
	<div class="head-serch">
		<el-form
			class="form"
			ref="hospitalSearchForm"
			:model="hospitalSearchForm"
			label-width="100px"
			@submit.native.prevent
			@keyup.enter.native="searchHandler"
		>
			<el-form-item label="医院名称">
				<el-input v-model="hospitalSearchForm.name" placeholder="请输入医院名称" />
			</el-form-item>
		</el-form>
		<el-button class="filter-item" size="mini" type="success" icon="el-icon-search" @click="searchHandler">搜索</el-button>
	</div>
</template>

<script>
export default {
	data() {
		return {
			hospitalSearchForm: {
				name: ''
			}
		};
	},
	created() {},
	methods: {
		searchHandler() {
			this.$emit('searchForm', this.hospitalSearchForm);
		}
	}
};
</script>

<style>
.form {
	display: flex;
}
</style>
